module.exports = __webpack_public_path__ + "static/media/Pre-authorized-debit-payment-backend-in-Rotessa.1a5d5bde.png";